//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { mapMutations, mapActions, mapGetters } from "vuex";
import FabricSearch from "@/components/q-fabric-search.vue";
import ApplicationsPage from "@/components/apps/applicationsPage/applicationsPage.vue";
import NoAppsPage from "@/components/apps/noAppsPage/noAppsPage.vue";
import AQChip from "@/components/Generics/AQChip/AQChip.vue";
import MobileHeader from "@/components/Mobile/MobileHeader.vue";

export default {
    name: "AppListMobile",
    components: {
        FabricSearch,
        ApplicationsPage,
        NoAppsPage,
        AQChip,
        MobileHeader
    },
    data() {
        return {
            searchText: "",
            normalFont: false,
            searchObject: {
                page: 0,
                search: "",
                ids: []
            },
            focus: false,
            appsFound: 0,
            elemScroll: 0,
            menuOpened: false,
            loading: true
        };
    },
    computed: {
        ...mapGetters("apps", ["allAppsNumber", "hasMoreApps", "getStaticAppIdsList", "noAppsToShow"])
    },
    mounted() {
        this.getUserDetails();
        this.getAppsNumber();
    },
    methods: {
        ...mapMutations("apps", ["resetPagedApps"]),
        ...mapActions("apps", ["getPagedApps", "getAppsNumber"]),
        ...mapActions("tasks", ["getUserDetails"]),
        loadMore() {
            const { header, subheader, layout, appsContainer } = this.$refs;
            const st = layout.scrollTop;
            const maintenanceMsg = document.getElementById("maintenanceMsg");

            if (st > this.elemScroll) {
                header.style.position = "relative";
                subheader.style.top = "0px";
            } else {
                header.style.position = "fixed";
                header.style.top = maintenanceMsg ? maintenanceMsg.style.top : "0";
                subheader.style.top = "58px";
                appsContainer.style.paddingTop = "58px";
                header.style.width = `${subheader.style.width}px`;
            }
            this.elemScroll = st <= 0 ? 0 : st;
            if (layout.scrollTop && this.hasMoreApps && layout.scrollTop + layout.offsetHeight >= layout.scrollHeight) {
                this.searchObject.page++;
                if (this.getStaticAppIdsList.length > 0) {
                    this.searchObject.ids = this.getStaticAppIdsList;
                }
                this.getPagedApps(this.searchObject);
            }
        },
        appSearch(searchText) {
            this.normalFont = !!searchText;
            this.searchObject.search = searchText || "";
            this.searchObject.page = 0;
            this.searchObject.ids = [];
            this.$store.commit("apps/resetPagedApps");
            this.getPagedApps(this.searchObject).then(data => {
                this.appsFound = data.data.appsNr;
            });
        },
        focusSearch() {
            if (this.$refs.search && this.$refs.search.$children.length) {
                this.$refs.search.$children[0].focus();
            }
        }
    }
};
